import { PropsWithChildren, useRef } from 'react';
import { noop } from 'lodash';
import { usePerspectiveEditorPortalSubscription } from 'perspectiveSidebar/perspectiveEditor/perspectivesEditor$/usePerspectiveEditorPortalSubscription';
import { ViewOptionsPerspectivesHeaderProperties } from './types';
import { useOnClickOutside } from '@ardoq/hooks';
import { connect } from '@ardoq/rxbeach';
import { ExtractStreamShape } from 'tabview/types';
import { viewOptionsPerspectivesPage$ } from './viewOptionsPerspectivesPage$';
import { ViewOptionsPerspectivesPageLayout } from './ViewOptionsPerspectivesPageLayout';

type ViewOptionsPerspectivesPageProps = PropsWithChildren<
  ViewOptionsPerspectivesHeaderProperties &
    ExtractStreamShape<typeof viewOptionsPerspectivesPage$> & {
      onClickOutside?: VoidFunction;
    }
>;

const ViewOptionsPerspectivesPageBase = ({
  onClickOutside,
  ...props
}: ViewOptionsPerspectivesPageProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(containerRef, onClickOutside ?? noop);
  usePerspectiveEditorPortalSubscription();

  return <ViewOptionsPerspectivesPageLayout ref={containerRef} {...props} />;
};

export const ViewOptionsPerspectivesPage = connect(
  ViewOptionsPerspectivesPageBase,
  viewOptionsPerspectivesPage$
);
